import {
  AvailableSubscriptionPackagesQuery,
  AvailableSubscriptionPackagesQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const SUBSCRIPTION_PACKAGES_QUERY = gql`
  query AvailableSubscriptionPackages {
    availableSubscriptionPackages {
      uid
      amountCents
      numCredits
      creditValue
      savingsPercentage
      savingsCents
      classPerWeekAvg
      numFreeCredits
    }
  }
`;

export function useSubscriptionPlans() {
  const { data, loading, error } = useQueryWithPreviousData<
    AvailableSubscriptionPackagesQuery,
    AvailableSubscriptionPackagesQueryVariables
  >(SUBSCRIPTION_PACKAGES_QUERY);
  return {
    subscriptionPlans: data?.availableSubscriptionPackages ?? [],
    loading,
    error,
  };
}
